(() => {
  const gridSelector = '#ProductGridContainer';
  const cardSelector = '#product-grid > li.column > .product-card';
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const collectionTitle = () => clean(document.querySelector('.template-header--title')?.textContent);

  const isBikeCollection = () => /bike|road|mountain|cross\s*country|\bxc\b|gravel|bmx|electric|tarmac|crux|rockhopper/i.test(collectionTitle());

  const collectionMark = () => {
    const title = collectionTitle();
    const parenthetical = title.match(/\(([^)]+)\)/)?.[1];
    if (parenthetical) return clean(parenthetical).slice(0, 4).toUpperCase();
    return title.split(/\s+/).filter(Boolean).slice(0, 2).map((word) => word[0]).join('').toUpperCase();
  };

  const updateHeader = () => {
    const header = document.querySelector('.section-template-header .template-header--content');
    if (!header) return;
    header.dataset.sierraMark = collectionMark();
    document.body.classList.toggle('sierra-collection--bike', isBikeCollection());

    const count = clean(document.querySelector('#ProductCount .facets__label')?.textContent);
    const headerCount = document.querySelector('[data-sierra-header-count]');
    if (count && headerCount) headerCount.textContent = count;
  };

  const enhanceFilter = () => {
    const form = document.querySelector('.facets-desktop-container .facets__form');
    if (!form || form.querySelector('.sierra-filter-heading')) return;
    const heading = document.createElement('div');
    heading.className = 'sierra-filter-heading';
    heading.innerHTML = '<span>Browse & refine</span><strong>Find your ride</strong>';
    form.prepend(heading);
  };

  const prioritizeAvailableProducts = () => {
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;

    const productItems = [...productGrid.children].filter((item) =>
      item.matches('li.column') && item.querySelector(':scope > .product-card')
    );
    if (productItems.length < 2) return;

    const sortedItems = [...productItems].sort((first, second) => {
      const firstAvailable = first.querySelector(':scope > .product-card')?.dataset.productAvailable !== 'false';
      const secondAvailable = second.querySelector(':scope > .product-card')?.dataset.productAvailable !== 'false';
      return Number(secondAvailable) - Number(firstAvailable);
    });

    if (productItems.every((item, index) => item === sortedItems[index])) return;

    const slots = productItems.map((item) => {
      const marker = document.createComment('sierra-product-slot');
      item.before(marker);
      return marker;
    });
    slots.forEach((slot, index) => slot.replaceWith(sortedItems[index]));
  };

  const enhanceCard = (card) => {
    if (card.dataset.sierraCollectionCard === 'true') return;
    const info = card.querySelector('.product-card-info');
    const image = card.querySelector('.product-featured-image');
    const link = card.querySelector('.product-card-title');
    if (!info || !image || !link) return;

    const available = card.dataset.productAvailable !== 'false';
    const footer = info.querySelector('.sierra-card-footer');
    if (footer) {
      const status = footer.querySelector('.sierra-card-status');
      if (status) {
        status.dataset.state = available ? 'available' : 'unavailable';
        status.textContent = available ? 'Available' : 'Unavailable';
      }
    }
    window.SierraCardInteractions?.enhance(card);
    card.dataset.sierraCollectionCard = 'true';
  };

  const enhance = () => {
    updateHeader();
    enhanceFilter();
    prioritizeAvailableProducts();
    document.querySelectorAll(cardSelector).forEach(enhanceCard);
  };

  const grid = document.querySelector(gridSelector);
  if (grid) {
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        enhance();
      });
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', enhance);
  enhance();
})();
